import { useEffect, useState } from 'react'
import { getAuthErrorMessage } from '../lib/authErrors'
import AuthError from '../components/AuthError'

function Home() {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Check for error in hash params (Supabase error redirects)
    const hashParams = new URLSearchParams(window.location.hash.substring(1))
    const hashError = hashParams.get('error')
    const errorCode = hashParams.get('error_code')
    const errorDescription = hashParams.get('error_description')

    if (hashError) {
      setError(getAuthErrorMessage(errorCode, errorDescription))
      // Clean up the URL
      window.history.replaceState(null, '', window.location.pathname)
    }
  }, [])

  if (error) {
    return (
      <AuthError
        title="Authentication Error"
        message={error}
        details="Please request a new link and try again."
      />
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <h1>Running Club</h1>
        <p>Account Management</p>
      </div>
      <div className="alert alert-info">
        This page handles authentication actions like password resets and email
        confirmations. You'll be redirected here automatically when clicking
        links in authentication emails.
      </div>
    </div>
  )
}

export default Home
